export default __webpack_public_path__ + "static/media/real_token.cc319977.svg";